var React = require('react');

function Stackoverflow (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"stackoverflow"),React.createElement("path",{"d":"M7.149 17.25h9.375v1.5h-9.375v-1.5z","key":1}),React.createElement("path",{"d":"M7.209 14.073l0.325-1.464 9.152 2.034-0.325 1.464-9.152-2.034z","key":2}),React.createElement("path",{"d":"M8.38 10.066l0.599-1.375 8.594 3.746-0.599 1.375-8.594-3.746z","key":3}),React.createElement("path",{"d":"M11.16 5.708l0.978-1.138 7.11 6.111-0.978 1.138-7.11-6.111z","key":4}),React.createElement("path",{"d":"M14.047 2.323l1.203-0.896 5.601 7.518-1.203 0.896-5.601-7.518z","key":5}),React.createElement("path",{"d":"M18.774 15.375v5.25h-13.875v-5.25h-1.5v6.75h16.875v-6.75h-1.5z","key":6})]);
}

Stackoverflow.defaultProps = {"version":"1.1","width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = Stackoverflow;

Stackoverflow.default = Stackoverflow;
